var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        [
          _c(
            "a-form-model",
            {
              ref: "formTitle",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.content.contentPath"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [_c("a-span", [_vm._v(_vm._s(_vm.contentPath))])],
                        1
                      )
                    ],
                    1
                  ),
                  !!_vm.id
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["emp.content.number"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { disabled: _vm.formDisabled },
                                model: {
                                  value: _vm.contentCode,
                                  callback: function($$v) {
                                    _vm.contentCode = $$v
                                  },
                                  expression: "contentCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { slot: "detail" }, slot: "detail" },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["emp.develop.contDetail"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "a-checkbox-group",
                    {
                      attrs: { disabled: _vm.formDisabled },
                      on: { change: _vm.languageCodeChange },
                      model: {
                        value: _vm.contentLangCodes,
                        callback: function($$v) {
                          _vm.contentLangCodes = $$v
                        },
                        expression: "contentLangCodes"
                      }
                    },
                    _vm._l(_vm.langList, function(item, index) {
                      return _c(
                        "a-checkbox",
                        { key: item.value, attrs: { value: item.value } },
                        [
                          _c("span", { staticStyle: { color: "#3260c9" } }, [
                            _vm._v(_vm._s(_vm.language[item.value]))
                          ])
                        ]
                      )
                    }),
                    1
                  ),
                  _c(
                    "a-tabs",
                    {
                      staticStyle: {
                        border: "1px solid #262626",
                        "border-radius": "5px"
                      },
                      attrs: {
                        disabled: "false",
                        activeKey: this.TabsActiveKey,
                        "default-active-key": "1",
                        disabled: _vm.formDisabled
                      },
                      on: { change: _vm.changeTabs }
                    },
                    _vm._l(_vm.contentLanglist, function(item, index) {
                      return _vm.contentLangCodes.indexOf(item.value) != -1
                        ? _c(
                            "a-tab-pane",
                            {
                              key: index,
                              attrs: { tab: _vm.language[item.value] }
                            },
                            [
                              _c(
                                "a-form-model",
                                {
                                  ref: "form",
                                  refInFor: true,
                                  attrs: {
                                    model: item,
                                    rules: _vm.validatorRules
                                  }
                                },
                                [
                                  _c(
                                    "a-row",
                                    [
                                      _c(
                                        "a-form-model-item",
                                        {
                                          attrs: {
                                            label:
                                              _vm.language[
                                                "emp.content.model6.serviceName"
                                              ],
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                            prop: "serviceName"
                                          }
                                        },
                                        [
                                          _c("a-input", {
                                            staticStyle: { width: "80%" },
                                            attrs: {
                                              placeholder:
                                                _vm.language["ad.must"] +
                                                _vm.language[
                                                  "emp.content.model6.serviceName"
                                                ],
                                              disabled: _vm.formDisabled
                                            },
                                            model: {
                                              value: item.serviceName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "serviceName",
                                                  $$v
                                                )
                                              },
                                              expression: "item.serviceName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-form-model-item",
                                        {
                                          attrs: {
                                            label:
                                              _vm.language[
                                                "emp.content.model6.serviceContent"
                                              ],
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol,
                                            prop: "serviceContent"
                                          }
                                        },
                                        [
                                          _c("a-input", {
                                            staticStyle: { width: "80%" },
                                            attrs: {
                                              placeholder:
                                                _vm.language["ad.must"] +
                                                _vm.language[
                                                  "emp.content.model6.serviceContent"
                                                ],
                                              disabled: _vm.formDisabled
                                            },
                                            model: {
                                              value: item.serviceContent,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "serviceContent",
                                                  $$v
                                                )
                                              },
                                              expression: "item.serviceContent"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-form-model-item",
                                        {
                                          attrs: {
                                            label:
                                              _vm.language[
                                                "emp.content.model6.contacts"
                                              ],
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol
                                          }
                                        },
                                        [
                                          _c("a-input", {
                                            staticStyle: { width: "80%" },
                                            attrs: {
                                              placeholder:
                                                _vm.language["ad.must"] +
                                                _vm.language[
                                                  "emp.content.model6.contacts"
                                                ],
                                              disabled: _vm.formDisabled
                                            },
                                            model: {
                                              value: item.contacts,
                                              callback: function($$v) {
                                                _vm.$set(item, "contacts", $$v)
                                              },
                                              expression: "item.contacts"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-form-model-item",
                                        {
                                          attrs: {
                                            label:
                                              _vm.language[
                                                "emp.content.model6.contactsPhone"
                                              ],
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol
                                          }
                                        },
                                        [
                                          _c("a-input", {
                                            staticStyle: { width: "80%" },
                                            attrs: {
                                              placeholder:
                                                _vm.language["ad.must"] +
                                                _vm.language[
                                                  "emp.content.model6.contactsPhone"
                                                ],
                                              disabled: _vm.formDisabled
                                            },
                                            model: {
                                              value: item.contactsPhone,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "contactsPhone",
                                                  $$v
                                                )
                                              },
                                              expression: "item.contactsPhone"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-form-model-item",
                                        {
                                          attrs: {
                                            label:
                                              _vm.language[
                                                "emp.content.model6.contactsMail"
                                              ],
                                            labelCol: _vm.labelCol,
                                            wrapperCol: _vm.wrapperCol
                                          }
                                        },
                                        [
                                          _c("a-input", {
                                            staticStyle: { width: "80%" },
                                            attrs: {
                                              placeholder:
                                                _vm.language["ad.must"] +
                                                _vm.language[
                                                  "emp.content.model6.contactsMail"
                                                ],
                                              disabled: _vm.formDisabled
                                            },
                                            model: {
                                              value: item.contactsMail,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "contactsMail",
                                                  $$v
                                                )
                                              },
                                              expression: "item.contactsMail"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-form-model",
            {
              ref: "formOther",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.col.sortNo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "sortNo"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 1,
                              max: 999999,
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["emp.col.sortNo"],
                              disabled: this.disabled
                            },
                            model: {
                              value: _vm.model.sortNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sortNo", $$v)
                              },
                              expression: "model.sortNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.col.colLevel"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "contentType"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "list",
                              dictCode: "emp_content_type",
                              disabled: _vm.formDisabled,
                              allowClear: ""
                            },
                            model: {
                              value: _vm.model.contentType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "contentType", $$v)
                              },
                              expression: "model.contentType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  this.$store.getters.applicationCode == "hhemp"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["legalperson"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol
                              }
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  attrs: {
                                    disabled: _vm.formDisabled || !!_vm.model.id
                                  },
                                  on: { change: _vm.legalPersonChange },
                                  model: {
                                    value: _vm.contentlegalPerson,
                                    callback: function($$v) {
                                      _vm.contentlegalPerson = $$v
                                    },
                                    expression: "contentlegalPerson"
                                  }
                                },
                                [
                                  _vm._l(_vm.legalpersonList, function(
                                    item,
                                    index
                                  ) {
                                    return [
                                      [
                                        index != 0
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "padding-right": "20px",
                                                  "padding-left": "10px"
                                                }
                                              },
                                              [_vm._v("|")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "a-radio",
                                          { attrs: { value: item.value } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#3260c9"
                                                }
                                              },
                                              [_vm._v(_vm._s(item.text))]
                                            )
                                          ]
                                        ),
                                        _vm.contentlegalPerson == item.value
                                          ? [
                                              _vm._v("("),
                                              _c(
                                                "a-checkbox",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      _vm.formDisabled ||
                                                      !!_vm.model.id
                                                  },
                                                  model: {
                                                    value: _vm.withOutsourcing,
                                                    callback: function($$v) {
                                                      _vm.withOutsourcing = $$v
                                                    },
                                                    expression:
                                                      "withOutsourcing"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#3260c9"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.language[
                                                            "emp.content.legalperson_withOutsourcing"
                                                          ]
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(")")
                                            ]
                                          : _vm._e()
                                      ]
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  this.$store.getters.applicationCode == "vnemp"
                    ? _c(
                        "div",
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: _vm.language["emp.content.bu"],
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "factoryCode"
                                  }
                                },
                                [
                                  _c("j-multi-select-tag", {
                                    staticClass: "factoryClass",
                                    staticStyle: { "margin-top": "10px" },
                                    attrs: {
                                      type: "checkbox",
                                      dictCode:
                                        this.$store.getters.applicationCode +
                                        "_content_factory",
                                      disabled: _vm.formDisabled
                                    },
                                    model: {
                                      value: _vm.model.factoryCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "factoryCode", $$v)
                                      },
                                      expression: "model.factoryCode"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.language["emp.content.factoryCode"],
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol
                                  }
                                },
                                [
                                  _c("j-multi-select-tag", {
                                    attrs: {
                                      type: "checkbox",
                                      dictCode:
                                        this.$store.getters.applicationCode +
                                        "_content_factory",
                                      disabled: _vm.formDisabled
                                    },
                                    model: {
                                      value: _vm.model.factoryCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "factoryCode", $$v)
                                      },
                                      expression: "model.factoryCode"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: _vm.language["emp.content.bg"],
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol
                                  }
                                },
                                [
                                  _c("j-multi-select-tag", {
                                    attrs: {
                                      type: "checkbox",
                                      dictCode:
                                        this.$store.getters.applicationCode +
                                        "_content_bg",
                                      disabled: _vm.formDisabled
                                    },
                                    model: {
                                      value: _vm.model.bg,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "bg", $$v)
                                      },
                                      expression: "model.bg"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["platform.roleUser.columns2.status"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "publishStatus"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "hhemp_publish_status",
                              disabled: ""
                            },
                            model: {
                              value: _vm.model.publishStatus,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "publishStatus", $$v)
                              },
                              expression: "model.publishStatus"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["emp.col.publishTime"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol
                              }
                            },
                            [
                              _c("j-date", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "",
                                  "date-format": "YYYY-MM-DD HH:mm:ss",
                                  disabled: _vm.formDisabled
                                },
                                model: {
                                  value: _vm.model.publishTimeHand,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "publishTimeHand", $$v)
                                  },
                                  expression: "model.publishTimeHand"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.model.publishStatus == "published"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.colVisible == true,
                                  expression: "colVisible==true"
                                }
                              ],
                              attrs: {
                                label: _vm.language["emp.col.publisher"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "publisher"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "",
                                  readOnly: true,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.model.publisher,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "publisher", $$v)
                                  },
                                  expression: "model.publisher"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    [
                      _vm.model.publishStatus == "published"
                        ? _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.colVisible == true,
                                      expression: "colVisible==true"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.language["emp.listing.time"],
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "publishTime"
                                  }
                                },
                                [
                                  _c("j-date", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "",
                                      "date-format": "YYYY-MM-DD HH:mm:ss",
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.model.publishTime,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "publishTime", $$v)
                                      },
                                      expression: "model.publishTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("language-model", {
            ref: "languageModel",
            on: { ok: _vm.languageOk }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }